<div class="card" (click)="card.click()">
    <div class="card-img-container">
        <img [src]="card.img" class="card-img-top">
    </div>
    <div class="card-body">
      <div class="card-btn">
      <div class="card-text" [ngClass]="{'model-text': card.isModel, 'node-text': !card.isModel}">
        <span>{{ card.title }}</span>
      </div>
      <img [src]="getIcon('RightArrow')" class="card-btn-icon">
    </div>
  </div>
</div>
